export var IMMEDIATE_PRIORITY = 0;
export var IDLE_HIGH_PRIORITY = 1;
export var IDLE_MEDIUM_PRIORITY = 2;
export var IDLE_LOW_PRIORITY = 3;
export var IDLE_VERYLOW_PRIORITY = 4;
//# sourceMappingURL=Models.js.map